import AuthService from './AuthService';

export const http = <T>(request: RequestInfo): Promise<IHttpResponse<T>> =>
  new Promise((resolve, reject) => {
    let response: IHttpResponse<T>;

    fetch(request)
      .then((res) => {
        response = res;
        if (res.status === 401) {
          AuthService.logout();
          // TODO: Find a better way to log the user out
          window.location.pathname = '/';
        }
        return res.text();
      })
      .then((text) => (text.length ? JSON.parse(text) : {}))
      .then((body) => {
        if (response.ok) {
          response.parsedBody = body;
          resolve(response);
        } else {
          reject(body);
        }
      })
      .catch((err) => {
        reject(err);
      });
  });

export const httpString = (request: RequestInfo): Promise<IHttpResponse<string>> =>
  new Promise((resolve, reject) => {
    let response: IHttpResponse<string>;

    fetch(request)
      .then((res) => {
        response = res;
        if (res.status === 401) {
          AuthService.logout();
          // TODO: Find a better way to log the user out
          window.location.pathname = '/';
        }
        return res.text();
      })
      .then((body) => {
        if (response.ok) {
          response.parsedBody = body;
          resolve(response);
        } else {
          reject(body);
        }
      })
      .catch((err) => {
        reject(err);
      });
  });

export const get = async <T>(
  path: string,
  args: RequestInit = { method: 'get' },
): Promise<IHttpResponse<T>> => http<T>(new Request(path, args));

export const getString = async (
  path: string,
  args: RequestInit = {
    method: 'get',
  },
): Promise<IHttpResponse<string>> => httpString(new Request(path, args));

export const post = async <T>(
  path: string,
  body: any,
  args: RequestInit = { method: 'post', body: JSON.stringify(body) },
): Promise<IHttpResponse<T>> => http<T>(new Request(path, args));

export const put = async <T>(
  path: string,
  body: any,
  args: RequestInit = { method: 'put', body: JSON.stringify(body) },
): Promise<IHttpResponse<T>> => http<T>(new Request(path, args));

export interface IHttpResponse<T> extends Response {
  parsedBody?: T;
}
